module.exports = __webpack_public_path__ + "media/images/blue-trash-ae4501731eca9b39a1c7574bc9ed1db5.svg";